import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Head from 'next/head';
import { APP_REDIRECT_STATUS } from '../actions/types';
import { setAppRedirectStatus } from '../actions/routerActions';

const getLocation = () => {
    return window.location.href;
}

const useRender301MetaTag = (redirectStatus, setAppRedirectStatus) => {
    const [render301MetaTag, setRender301MetaTag] = useState(false);

    const render301RedirectTag = () => {
        setRender301MetaTag(true);

        setAppRedirectStatus(APP_REDIRECT_STATUS.REDIRECTED);
    };

    useEffect(() => {
        if (redirectStatus === APP_REDIRECT_STATUS.INITIALISED) {
            render301RedirectTag();
        }
    }, [redirectStatus]);

    return render301MetaTag;
};

const PageHeadOptionalMetaTags = ({ redirectStatus, setAppRedirectStatus }) => {
    const render301MetaTag = useRender301MetaTag(redirectStatus, setAppRedirectStatus);

    if (!render301MetaTag) {
        return null;
    }

    return (
        <Head>
            <meta name="prerender-status-code" content="301" />
            <meta name="prerender-header" content={`Location: ${getLocation()}`} />
        </Head>
    );
};

const mapStateToProps = ({ redirect }) => {
    return {
        redirectStatus: redirect.status,
    };
};

export default connect(mapStateToProps, { setAppRedirectStatus })(PageHeadOptionalMetaTags);
